import { Api } from './Api';

const  ENPOINTS = {
    TypePaiement: 'type-paiements',
};

const getAll = signal => {
    return Api.get(ENPOINTS.TypePaiement, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.TypePaiement}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.TypePaiement, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.TypePaiement}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.TypePaiement}/${id}`, signal)
}

export const TypePaiementService = {
    getAll,
    getById,
    create,
    update,
    destroy
}